import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Contact } from 'src/app/models';

@Component({
  selector: 'app-test-contact-popup',
  templateUrl: './test-contact-popup.component.html',
  styleUrls: ['./test-contact-popup.component.scss']
})
export class TestContactPopupComponent {
    contacts: Contact[];
    selectedContact: Contact;

    constructor(public dialog: MatDialogRef<TestContactPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Contact[]) {
          this.contacts = this.data;
    }
}
